export default __webpack_public_path__ + "static/media/NoteApp_thumb.8600cb9e.jpg";